(function () {
  function initSmoothLinks(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.frlSmooth === "true") return;
      link.dataset.frlSmooth = "true";

      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href");
        if (!id || id === "#") return;

        var target = document.querySelector(id);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function initListicle(root) {
    if (!root || root.dataset.frlInitialized === "true") return;
    root.dataset.frlInitialized = "true";
    initSmoothLinks(root);
  }

  function initAll() {
    document.querySelectorAll(".frl").forEach(initListicle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(".frl");
    if (root) initListicle(root);
  });
})();
